import Swal from "sweetalert2";
import * as Type from "store/actionTypes/productModel";
import {
  getProductModels,
  createProductModel as createProductModelService,
  updateProductModel as updateProductModelService,
  deleteProductModel as deleteProductModelService,
} from "services";

export const getProductModel =
  (params = "") =>
  async (dispatch) => {
    try {
      dispatch({
        type: Type.PRODUCT_MODEL_REQUEST,
      });
      const res = await getProductModels(params);
      dispatch({
        type: Type.GET_PRODUCT_MODEL_SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      Swal.fire("error", err.message, "error");
      dispatch({
        type: Type.GET_PRODUCT_MODEL_ERROR,
        payload: err.message,
      });
    }
  };

export const createProductModel = (data) => async (dispatch) => {
  try {
    dispatch({
      type: Type.PRODUCT_MODEL_REQUEST,
    });
    const res = await createProductModelService(data);
    Swal.fire("success", res.message, "success");
    dispatch({
      type: Type.CREATE_PRODUCT_MODEL_SUCCESS,
      payload: res.message,
    });
  } catch (err) {
    Swal.fire("error", err.message, "error");
    dispatch({
      type: Type.CREATE_PRODUCT_MODEL_ERROR,
      payload: err.message,
    });
  }
};

export const updateProductModel = (data, id) => async (dispatch) => {
  try {
    dispatch({
      type: Type.PRODUCT_MODEL_REQUEST,
    });
    const res = await updateProductModelService(data, id);
    Swal.fire("success", res.message, "success");
    dispatch({
      type: Type.UPDATE_PRODUCT_MODEL_SUCCESS,
      payload: res.message,
    });
  } catch (err) {
    Swal.fire("error", err.message, "error");
    dispatch({
      type: Type.UPDATE_PRODUCT_MODEL_ERROR,
      payload: err.message,
    });
  }
};

export const deleteProductModel = (id) => async (dispatch) => {
  try {
    dispatch({
      type: Type.PRODUCT_MODEL_REQUEST,
    });
    const res = await deleteProductModelService(id);
    Swal.fire("success", res.message, "success");
    dispatch({
      type: Type.DELETE_PRODUCT_MODEL_SUCCESS,
      payload: res.message,
    });
  } catch (err) {
    Swal.fire("error", err.message, "error");
    dispatch({
      type: Type.DELETE_PRODUCT_MODEL_ERROR,
      payload: err.message,
    });
  }
};
